import {MainVideoState} from "../definitions/MainVideoState";

export const videoBuffering = (state: MainVideoState) => {
    state.videoIsBuffering = true;
};
